<template>
	<el-main class="down_main">
		<div class="vertical recruit-body">
			<el-dialog title="下载海报" width="302px" :visible.sync="Dialog_model" :close-on-click-modal='true'>
				<div class="down_phone_url">
					<img class="down_phone_saoma" :src="saomaUrl" />
					<img class="down_phone_img" :src="down_phone_url" style="" />
				</div>
				<div class="recruit-dialog-desc">手机扫码下载至手机</div>
				<el-button style="width: 160px;height: 40px;text-align: center;background-color: #0486FE;color: #ffffff;margin: 20px auto 0;display: block;" @click="downloadImg()"> 下载至本地 </el-button>
			</el-dialog>
			<!-- <div class="zhaomu">
				<div class="pc_ewm">
					<p style="font-size: 26px;font-family: PingFang-SC-Bold, PingFang-SC;font-weight: bold;color: #333333;margin-bottom: 8px;">招募合伙人</p>
					<p style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #999999;">下载二维码自定义招募海报分享好友</p>
					<div class="ewm_view">
						<img v-if="down_pc_url" :src="down_pc_url" style="width: 128px;height: 128px;margin-top: 38px;" />
					</div>
					
					  
					  <a type="primary"  :href='url+down_pc_url'>
						<el-button style="height: 40px;text-align: center;margin-top: 40px;background-color: #0486FE;color: #ffffff;"> 下载至本地 </el-button></a>
						
				</div>
				<div class="phone">
					 <img v-if="down_phone_url" :src="down_phone_url" style="width: 128px;height: 128px;margin-top: 146px;" />
					 <div v-if="!down_phone_url" style="width: 128px;height: 128px;margin-top: 146px;"></div>
					 <p class="cmsj">扫码下载至手机</p>
				</div>
			</div> -->
			<div class="recruit-main">
				<div class="recruit-left">
					<div class="recruit-img-view">
						<img :style="{height:divheight}" class="recruit-img" :src="imginfo.url" />
						<div class="upload-view" v-if="showUpload">
							<i class="el-icon-upload"></i>
							<div class="upload-txt">上传海报</div>
						</div>
						<el-upload
							 v-loading="loading"
						    ref="upload_img"
							:show-file-list="false"
							:headers="upload.headers"
							:action="upload.url"
							:on-success="getfile"
							:multiple="false"
							:before-upload="beforeAvatarUpload"
							:on-progress="onthecross"
							class="upload-mask"
							>
						<div class="upload-mask-div" @mouseenter="changeUpload()" @mouseleave="changeUpload()"></div>
						</el-upload>
						<!-- <img :style="{bottom:getBottom+'px',right:getRight+'px',width:getWidth+'px',height:getWidth+'px'}" class="qrcode-img" v-if="down_pc_url" :src="down_pc_url" /> -->
						<img :style="imgstyle" class="qrcode-img" v-if="down_pc_url" :src="down_pc_url" />
					</div>
					<div class="recurit-tip">
						建议比例9:16，图片宽高需 >300px
					</div>
				</div>
				<div class="recruit-right">
					<div class="recruit-title">专属合伙人招募-自定义设置</div>
					<div class="recruit-content">招募深度合作的社群，其它社群不享受专属计划高佣金激励，出单可控</div>
					<div class="recruit-desc">二维码参数</div>
					<div class="recruit-size">
						<div class="recruit-label">距底</div>
						<el-input-number :step-strictly="true" size="small" v-model="bottom" @change="handleChangey" :min="0" :max="imgheight-width" label="距底"></el-input-number>
						<div class="recruit-px">px</div>
						<div class="recruit-label recruit-toright">距右</div>
						<el-input-number :step-strictly="true" size="small" v-model="right" @change="handleChangex" :min="0" :max="imgwidth-width" label="距右"></el-input-number>
						<div class="recruit-px">px</div>
					</div>
					<div class="recruit-size">
						<div class="recruit-label">宽度</div>
						<el-input-number :step-strictly="true" size="small" v-model="width" @change="handleChangew" :min="50" :max="imgwidth>imgheight?imgheight-bottom:imgwidth-right" label="宽度"></el-input-number>
						<div class="recruit-px">px</div>
						<div class="qrcode-width-desc">比例1:1，二维码宽度需≥50px</div>
					</div>
					<div class="recruit-btn">
						<el-button style="width: 110px;height: 40px;text-align: center;background-color: #0486FE;color: #ffffff;" @click="saveInfo()"> 保存 </el-button>
						<!-- <el-button style="height: 40px;text-align: center;background-color: #0486FE;color: #ffffff;" @click="downloadImg()"> 下载至本地 </el-button> -->
						<!-- <a class="hide" id="downlocal" type="primary"  :href='url+posterurl'></a> -->
			            <el-button @click="changeDialog()" style="width:110px;height: 40px;text-align: center;background-color: #fff;color: #0486FE;border: 1px solid #DCDFE6;margin-left: 30px;"> 下载海报 </el-button>
						<el-button @click="setting()" style="width:110px;height: 40px;text-align: center;background-color: #fff;color: #0486FE;border: 1px solid #DCDFE6;margin-left: 30px;"> 合作设置 </el-button>
					</div>
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
	import {getDownload,savePosterInfo} from '../../api/partner';
	import { baseURL, noPermissionCode} from '@/config';
	import { handleCode } from '@/utils/request';
	export default {
	    data() {
	        return {
			   loading:false,
			   recruit_id:0,
			   Dialog_model:false,
	           down_pc_url:'',
			   posterurl:'',
			   down_phone_url:'',
			   saomaUrl:baseURL+'/public/images/saoma.png',
			   url:baseURL+"/Api/brand.NoAuth/downRecruitQrcode?down_url=",
			   bottom:12,
			   right:12,
			   width:96,
			   imgwidth:300,
			   imgheight:533,
			   divwidth:250,
			   divheight:445,
			   zoom:5/6,
			   upload: {
			    // 设置上传的请求头部
			     headers: { authorization: this.$store.getters['user/accessToken'] ? this.$store.getters['user/accessToken'] : '' },
			     // 上传的地址
			     url: baseURL + '/api/brand.Upload/oneToOssWH'
			   },
			   showUpload:false,
			   imginfo:{
				   id:0,
				   url:''
			   },
	        };
	    },
		computed: {
			imgstyle:function() {
			  var bottom = this.bottom * this.zoom;
			  var right = this.right * this.zoom;
			  var width = this.width * this.zoom;
			  return 'bottom:' + bottom + 'px;right:' + right + 'px;width:'+width+'px;height:'+width+'px;';
			},
			// getBottom: function () {
			// 	var height = this.divheight;
			// 	var width = this.width * this.zoom;
			// 	var bottom = this.bottom * this.zoom;
			// 	if(bottom*1+width*1 > height){
			// 		bottom = height - width;
			// 	}
			// 	return bottom;
			// },
			// getRight: function () {
			// 	var width = this.width * this.zoom;
			// 	var right = this.right * this.zoom;
			// 	if(right*1+width*1 > this.divwidth){
			// 		right = this.divwidth - width;
			// 	}
			// 	return right;
			// },
			// getWidth: function () {
			// 	var width = this.width * this.zoom;
			// 	var height = this.divheight;
			// 	if(width > this.divwidth || width > height){
			// 		width = this.divwidth>height?height:this.divwidth;
			// 	}
			// 	return width;
			// },
		},
		created() {
		   this.getDownload();
		},
	    methods: {
			changeUpload(){
				this.showUpload = !this.showUpload;
			},
			onthecross(){
				this.loading = true;
				
			},
			//上传完成
			getfile(response, file){
				this.loading = false;
			    if(response.code == noPermissionCode){
				    handleCode(response.code,response.message);
			    }else if(response.code==40000){
					this.$message.error(response.message);
				}else{
				    var data = {id: response.data.id, url: response.data.url};
					this.imgwidth = response.data.width;
					this.imgheight = response.data.height;
					this.zoom = this.divwidth/response.data.width;
					this.width = 80/this.zoom;
					this.bottom = 10/this.zoom;
					this.right = 10/this.zoom;
					this.imginfo = data;
				}
			    this.$refs.upload_img.clearFiles(); //上传成功之后清除历史记录
			},
			beforeAvatarUpload(file) {
				if (file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/gif') {
					this.$message.error('上传图片只能是 JPG、PNG、GIF 格式!');
					return false;
				}
			},
			downloadImg(){
				var link = document.createElement("a");
				link.download = 'muban';
				link.href = this.url + this.posterurl;
				link.click();
				link.remove();
			},
			saveInfo(){
				savePosterInfo(
					{
						'id':this.recruit_id,
						'poster':this.imginfo.id,
						'width':this.imgwidth,
						'height':this.imgheight,
						'qr_width':this.width,
						'qr_x':this.right,
						'qr_y':this.bottom
					}
				).then(res => {
					if(res.code==0){
						this.$message.success(res.message);
						this.down_phone_url = res.data.down_url;
						this.posterurl = res.data.posterimg;
						this.recruit_id = res.data.id;
						// var link = document.createElement("a");
						// link.download = 'muban';
						// link.href = this.url + this.posterurl;
						// link.click();
						// link.remove();
						
						// var a = document.getElementById('downlocal');
						// a.click();
					}else{
						this.$message.error(res.message);
					}
				})
			},
			handleChangex(val) {
				this.right = val;
			},
			handleChangey(val) {
				this.bottom = val;
			},
			handleChangew(val) {
				this.width = val;
			},
			changeDialog(){
				if(this.Dialog_model){
					this.Dialog_model = false;
				}else{
					savePosterInfo(
						{
							'id':this.recruit_id,
							'poster':this.imginfo.id,
							'width':this.imgwidth,
							'height':this.imgheight,
							'qr_width':this.width,
							'qr_x':this.right,
							'qr_y':this.bottom
						}
					).then(res => {
						if(res.code==0){
							this.down_phone_url = res.data.down_url;
							this.posterurl = res.data.posterimg;
							this.recruit_id = res.data.id;
							this.Dialog_model = true;
						}else{
							this.$message.error(res.message);
						}
					})
					
				}
			},
			getDownload(){
				getDownload().then(res => {
					 if(res.code == 0){
						 this.down_pc_url =  res.data.qrcode_img;
						 this.down_phone_url = res.data.down_url;
						 this.posterurl = res.data.posterimg;
						 this.imginfo = {
							 id:res.data.recruit_info.poster,
							 url:res.data.recruit_info.posterimg
						 };
						 this.bottom = res.data.recruit_info.qr_y;
						 this.width = res.data.recruit_info.qr_width;
						 this.right = res.data.recruit_info.qr_x;
						 this.imgwidth = res.data.recruit_info.width;
						 this.imgheight = res.data.recruit_info.height;
						 this.recruit_id = res.data.recruit_info.id;
						 this.zoom = this.divwidth/this.imgwidth;
					 }
				});
			},
			setting(){
				this.$router.push({
					path: '/customer/partner-setting',
				});
			}
	    }
	};
</script>

<style scoped>
	.recruit-body .el-dialog__body{
		padding: 30px 20px;
	}
	.down_main{
		width: 100%;
		height: 88vh;
		background: #ffffff;
		position: relative;
	}
	.vertical{
		width: 100%;
		height: 491px;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
	}
	.recruit-main{
		margin-left: 68px;
		display: flex;
		align-items: center;
	}
	.recruit-img-view{
		width: 250px;
		border-radius: 10px;
		position: relative;
		border: 1px solid #CCCCCC;
	}
	.recruit-img{
		width: 250px;
		border-radius: 10px;
		object-fit: contain;
		display: block;
	}
	.upload-mask{
		position: absolute;
		z-index: 10;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
	}
	.upload-mask-div{
		position: absolute;
		z-index: 11;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
	}
	.upload-view{
		width: 100px;
		height: 100px;
		background: rgba(0,0,0,0.5);
		border-radius: 4px;
		position: absolute;
		z-index: 9;
		left: 75px;
		top: 50%;
		margin-top: -50px;
		text-align: center;		
		color: #FFFFFF;
	}
	.upload-view .el-icon-upload{
		font-size: 50px;
		margin-top: 10px;
		
	}
	.upload-txt{
		font-size: 12px;
		font-weight: 500;
	}
	.recurit-tip{
		font-size: 12px;
		font-weight: 500;
		color: #666666;
		margin-top: 15px;
		
	}
	
	.qrcode-img{
		position: absolute;
		z-index: 8;
	}
	.recruit-right{
		margin-left: 60px;
	}
	
	.recruit-title{
		height: 40px;
		font-size: 26px;
		font-family: PingFang-SC-Bold, PingFang-SC;
		font-weight: bold;
		color: #333333;
		line-height: 40px;
	}
	.recruit-content{
		height: 24px;
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
		margin-top: 6px;
	}
	.recruit-desc{
		height: 24px;
		font-size: 16px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		line-height: 24px;
		margin-top: 48px;
	}
	.recruit-size{
		display: flex;
		align-items: center;
		height: 60px;
		font-size: 14px;
		font-weight: 500;
		color: #606266;
	}
	.recruit-label{
		font-size: 14px;
		font-weight: 500;
		color: #333333;
		margin-right: 10px;
	}
	.qrcode-width-desc{
		font-size: 12px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #666666;
		margin-left: 20px;
	}
	.recruit-px{
		margin-left: 5px;
	}
	.recruit-toright{
		margin-left: 30px;
	}
	.recruit-btn{
		margin-top: 78px;
		display: flex;
	}
	.hide{
		display: none;
	}
	/* .zhaomu{
		display: flex;
		justify-content: center;
	}
	.pc_ewm{
		text-align: center;
	}
	.ewm_view{
		width: 200px;
		height: 200px;
		background: #FFFFFF;
		border-radius: 4px;
		border: 1px solid #CCCCCC;
		margin: 0 auto;
		margin-top: 34px;
	}
	.phone{
		width: 254px;
		height: 491px;
		background-image: url(../../assets/img/partner/phone.png);
		background-size: cover;
		margin-left: 116px;
		text-align: center;
	}
	.cmsj{
		font-size: 16px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		margin-top: 50px;
	} */
	.recruit-dialog-desc{
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
		text-align: center;
	}
	.down_phone_url{
		width: 205px;
		height: 196px;
		margin: 0 auto 10px;
		position: relative;
		display: flex;
		align-items: center;
	}
	.down_phone_saoma{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		z-index: 1;
		left: 0;
	}
	.down_phone_img{
		width: 173px;
		height: 173px;
		margin:0 auto;
		display: block;
	}
</style>
